import {useRef,useState} from 'react';
import {checkSkuPalpa} from '../../integration/Api.js';
import {consoleLog} from '../../../core/utilities/Utilities.js';
import {useLoading} from '../LoadingContext';
import SKUPalpaCheckPopup from './SKUPalpaCheckPopup.js';

//Add product to a sales/storage order: warn when a DBRS SKU is not found in Palpa - the user can still add it.
//Palpa errors/timeouts let the add go through (no dialog)
const useSKUPalpaAddCheck=(application)=>{
    const {showLoading,hideLoading}=useLoading();
    const [openPalpaPopup,setOpenPalpaPopup]=useState(false);
    const palpaItemsRef=useRef([]);
    const pendingAddRef=useRef(null);

    const checkPalpaBeforeAdd=async(skuId,addSku)=>{
        showLoading();
        const response=await checkSkuPalpa({sku_id:skuId});
        hideLoading();
        consoleLog({file:'useSKUPalpaAddCheck.js',context:'checkPalpaBeforeAdd',arg_name:'response',arg_value:response});
        const palpaItems=response?.palpa_items||[];
        if(palpaItems.length===0){
            addSku();
            return;
        }
        palpaItemsRef.current=palpaItems;
        pendingAddRef.current=addSku;
        setOpenPalpaPopup(true);
    };

    const popupPalpaCheckCallBack=(proceed)=>{
        setOpenPalpaPopup(false);
        if(proceed&&pendingAddRef.current){
            pendingAddRef.current();
        }
        pendingAddRef.current=null;
    };

    const palpaPopup=openPalpaPopup?(
        <SKUPalpaCheckPopup
            popupPalpaCheckCallBack={popupPalpaCheckCallBack}
            items={palpaItemsRef.current}
            message={application.getLocale('MsgPalpaNotRegisteredAdd')}
            canProceed={true}
            proceedLabel={'ButtonAddAnyway'}
            application={application}/>
    ):null;

    return {checkPalpaBeforeAdd,palpaPopup};
};

export default useSKUPalpaAddCheck;
